import { useContext } from 'react';
import type { TranslationKey } from '../types';
import defaultTranslations from './defaultTranslations';
import { DEFAULT_LOCALE } from './defaultLocale';
import { TranslationContext } from './TranslationContext';

export const useTranslationContext = () => useContext(TranslationContext);

export const useTranslations = (
  language: string = DEFAULT_LOCALE,
): Record<TranslationKey, string> => {
  const { translations } = useTranslationContext();

  const hasRequestedLanguage = !!translations[language as keyof typeof translations];

  const resolvedLanguage = hasRequestedLanguage ? language : DEFAULT_LOCALE;

  const selectedTranslations = translations[resolvedLanguage as keyof typeof translations];

  //TODO: PMAR-1309 - Refactor: simplify useTranslations
  //https://jira.kindredgroup.com/browse/PMAR-1309
  return new Proxy(selectedTranslations, {
    get: (target, prop) => {
      if (typeof prop !== 'string') {
        return target[prop as unknown as keyof typeof target];
      }

      const value = target[prop as keyof typeof target];

      if (value !== null && value !== undefined && value !== '') {
        return value;
      }

      const langFallback =
        defaultTranslations[resolvedLanguage as keyof typeof defaultTranslations]?.[
          prop as keyof typeof target
        ];
      if (langFallback !== null && langFallback !== undefined && langFallback !== '') {
        return langFallback;
      }

      const enFallback =
        defaultTranslations.en_GB?.[prop as keyof typeof defaultTranslations.en_GB];
      if (enFallback !== null && enFallback !== undefined && enFallback !== '') {
        return enFallback;
      }

      return '';
    },
  }) as Record<TranslationKey, string>;
};
